<template>
		<section class="section section-lg pt-0">
            <div class="container">
                <card gradient="success"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class=" align-items-center text-center justify-content-center">
                        	<div class="row flex-column-reverse flex-lg-row">
                        		
                                <div class="rounded overflow-hidden col-lg-6">
	                            	<b-carousel id="carousel2"
	                                    controls
	                                    indicators      
	    								@sliding-start="onSlideStart" @sliding-end="onSlideEnd" >
			                            <!-- Text slides with image -->
			                            <b-carousel-slide img-src="img/testimonial/background_testi.jpg" > 
			                            	 <blockquote class="blockquote ">
							                    <p class="lead  text-black">ZeroInside dapat mengerjakan project dengan baik dengan harga sesuai kantong mahasiswa </p>
							                    <footer class="blockquote-footer text-white">Vanya Sukmana Putri 
							                        <cite title="Source Title">(Mahasiswi Telkom)</cite>
							                    </footer>
							                </blockquote>
			                            </b-carousel-slide>
			                            <b-carousel-slide img-src="img/testimonial/background_testi.jpg"  >
									           <blockquote class="blockquote ">
							                    <p class="lead  text-black">Saya puas dengan projek yang dikerjakan, fitur yang dikerjakan berjalan dengan baik. Sukses terus ZeroInside!</p>
							                    <footer class="blockquote-footer text-white">Hilal Nabil Abdillah
							                        <cite title="Source Title">(Alumni Telkom)</cite>
							                    </footer>
							                </blockquote>
			                            </b-carousel-slide>
			                            <b-carousel-slide img-src="img/testimonial/testimoni_dyah.jpg" > 
			                            	
			                            </b-carousel-slide>
			                            <b-carousel-slide img-src="img/testimonial/background_testi.jpg"  >
									           <blockquote class="blockquote ">
							                    <p class="lead  text-black">Alhamdulillah membimbing kali, bisa bantuin PAku, sabar ngadapin aku dan Ayidha yang lemot, walaupun kami sabar ngadapin kau yang sibuk.</p>
							                    <footer class="blockquote-footer text-white">Gundari Amboro S
							                        <cite title="Source Title">(Alumni Telkom)</cite>
							                    </footer>
							                </blockquote>
			                            </b-carousel-slide>
			                        </b-carousel>
                            	</div>
                            	<br>
                            	<div class="col-lg-6 ">
                                	<h3 class="text-white">Testimonials </h3>
                                	<p class="text-white lead"> Some good words from our happy clients!</p>
                                	<div class="row "> 
	                                	      <card shadow class="shadow-lg--hover mt-5 floating">
						                            <div class="d-flex px-3">
						                                <div>
						                                    <icon name="ni ni-satisfied" gradient="success" color="white" shadow
						                                          rounded></icon>
						                                </div>
						                                <div class="pl-4">
						                                    <h5 class="title text-success">Good Feedback</h5>
						                                    <p>Kami mencoba untuk memenuhi kebutuhan client dengan maksimal.
						                                        Setelah project selesai, kami akan meminta review anda untuk meningkatkan kualitas kami kedepannya.</p>
						                                   
						                                </div>
						                            </div>
						                        </card>
	                      
                                	</div>
                            	</div>

                        	</div>
                            
                        
                        </div>
                    </div>
                </card>
            </div>
        </section>
</template>
<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";

export default {
  components: {
    BCarousel,
    BCarouselSlide
  }
};
</script>